<!--
* 组件名 : 段落文字组件
* 开发者 : JY
*
* 参数:
*  title      { String }   []       - 神话标题
*  html       { Object }   required - 文字内容
*  isGodsWord { Boolean }  [ false ]   - 是否为神话专版
*
* 事件:  null
*
-->

<template>
  <div class="text-content-wrap" ref="textContentWrap">
    <v-background v-if="isGodsWord" :src="bgImg" :isUseI18n="false" />
    <div
      :class="[
        'text-content content-box set-font-size',
        isUnf ? 'unfold' : '',
        noLimit,
      ]"
      ref="textContent"
    >
      <h2 v-if="title">{{ title }}</h2>
      <div class="v-text-content" v-html="html" ref="limitWrap" />
      <div class="next-arrow-box">
        <v-btn @btnClick="read_more" class-name="page-arrow">
          {{ btnText }} <v-icon>expand_more</v-icon>
        </v-btn>
      </div>
    </div>
    <div v-if="isGodsWord" class="v-page-content" />
  </div>
</template>

<script>
import { i18n, timeout } from "@/utils/util";

export default {
  name: "v-text-content",
  props: {
    html: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: "",
    },
    isGodsWord: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isUnf: false,
      btnText: this.$TL.expandAll,
      noLimit: "",
      bgImg: i18n("images/common/bg-2.jpg"),
      scrollH: 0,
    };
  },
  created() {},
  mounted() {
    this.count_text_rows();
    this.mythology_edition();
  },
  methods: {
    //  原生获取属性值
    get_style(ele, attr) {
      return Number(window.getComputedStyle(ele, null)[attr].replace("px", ""));
    },
    //  计算文字的行数
    count_text_rows() {
      //  先判断文字是否超过一屏
      if (this.$refs.limitWrap.clientHeight < window.innerHeight * 2 + 280) {
        this.noLimit = "no-limit";
        return;
      }
      this.box_max_height();

      this.opacity_animate();
    },
    /**
     * 计算内容盒子最大高度
     */
    box_max_height() {
      let [childH, boxMaxH, nodeArry] = [0, 0, []];

      //  得到最后被切掉的那段文字和包含该段文字时盒子的高度
      [...this.$refs.limitWrap.childNodes].map((item, i) => {
        childH += $(item).outerHeight(true);
        if (childH >= window.innerHeight * 2) {
          if (nodeArry.length > 0) return;
          boxMaxH = childH;
          nodeArry.push(item);
        }
      });
      //  单独给最后未显示全的那段文字加限行，其余隐藏的disply:none 掉
      [...nodeArry].map((item, i) => {
        let H = item.clientHeight - (boxMaxH - window.innerHeight * 2);
        let rows = Math.round(H / this.get_style(item, "lineHeight"));
        let lineH =
          this.get_style(item, "lineHeight") / this.get_style(item, "fontSize");
        let maxH = `calc(${lineH.toFixed(2)}em * ${rows})`;

        $(item)
          .addClass("limit")
          .attr({
            style: `max-height:${maxH}; -webkit-line-clamp: ${rows}`,
          })
          .nextAll()
          .addClass("d-none");
      });
    },
    /**
     * 文章展开收起操作
     */
    read_more() {
      if (this.isUnf) {
        this.btnText = this.$TL.expandAll;
        //  重新计算下限行高度
        this.count_text_rows();
        this.isUnf = false;
      } else {
        this.btnText = this.$TL.packUp;
        this.scrollH = $(window).scrollTop();
        $(this.$refs.limitWrap)
          .find("p, h2")
          .removeClass("limit d-none");
        this.isUnf = true;
      }

      $(window).scrollTop(this.scrollH);
    },
    /**
     * 判断是否为神话专版内容
     */
    mythology_edition() {
      if (this.isGodsWord) {
        $(this.$refs.textContent)
          .attr("words_edition", true)
          .find("p:not(.gold):not(.from)")
          .addClass("human-word");
      }
    },
    /**
     *  展开收起渐隐动画
     */
    opacity_animate() {
      $(this.$refs.limitWrap)
        .css("opacity", 0)
        .velocity({
          opacity: 1,
        });
    },
  },
};
</script>

<style lang="scss">
.text-content-wrap {
  position: relative;
  height: auto;
}

.text-content {
  padding-top: 84px;
  padding-bottom: 112px;

  &.unfold {
    height: auto;

    p {
      text-overflow: initial;
      -webkit-line-clamp: initial !important;
      max-height: none !important;
    }

    .page-arrow {
      i {
        transform: rotate(180deg);
      }
    }
  }

  &.no-limit {
    @include flex(null, center, wrap, column);

    .next-arrow-box {
      display: none;
    }
  }

  &[words_edition] {
    .page-arrow {
      color: $color-white;
      i {
        color: $color-white !important;
      }
    }
  }

  h2 {
    width: 100%;
    font-size: calc(var(--font-size) + 4px);
    color: $color-god-words-title;
    text-align: center;
    margin-bottom: 28px;
  }
}

.next-arrow-box {
  width: 100%;
  margin-top: 24px;
  @include flex(center, center);

  .page-arrow {
    margin: auto;

    span,
    i {
      color: inherit !important;
    }
  }
}

.v-text-content {
  transform: translateZ(0);

  p {
    margin-bottom: 16px;
    line-height: 1.8;
    font-size: var(--font-size);

    &:last-of-type(1) {
      margin-bottom: 0;
    }

    &.limit {
      display: block;
      display: -webkit-box;
      text-overflow: ellipsis;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
  }

  .gold {
    color: $color-god-words-title;
    font-size: var(--font-size);
  }

  .bigMarginBot,
  .human-word {
    color: $color-white;
  }

  .bigMarginBot {
    font-size: calc(var(--font-size) - 2px);
    margin-bottom: 46px;
  }

  .human-word {
    opacity: 0.9;
    font-size: calc(var(--font-size) - 1px);
  }

  //  神话摘自
  .from {
    margin-bottom: 28px;
    font-size: calc(var(--font-size) - 2px);
    line-height: 1.5;
    color: $color-from;
    text-align: right !important;
  }
}

body.ie11 {
  .next-arrow-box {
    display: block;
  }
}

body[data-lang="zh-TW"],
body[data-lang="zh-CN"] {
  .v-text-content {
    p {
      text-indent: 2em;
      letter-spacing: 0.5px;
      text-align: justify;
    }
  }
}
</style>
